var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1132"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1132"
    },
    "bundlingPackage": "MeetingsPublic",
    "bundlingPackageVersion": "static-1.59763",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};